/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type TalentPoolResponseKind = typeof TalentPoolResponseKind[keyof typeof TalentPoolResponseKind];


export const TalentPoolResponseKind = {
  global: 'global',
  tenant: 'tenant',
} as const;
